export var ButtonVariants;
(function (ButtonVariants) {
    ButtonVariants["Gray"] = "gray";
    ButtonVariants["Red"] = "red";
})(ButtonVariants || (ButtonVariants = {}));
